import React, { FC } from 'react'
import { chip, chipIcon, chipText, chipIconContainer } from './chip.css'
import { Icon } from '@hermes/design-system'

type ChipProps = {
  name: string
}

export const Chip: FC<ChipProps> = ({ name }) => {
  return (
    <div className={chip}>
      <div className={chipIconContainer}>
        <Icon name="check" className={chipIcon} />
      </div>
      <span className={chipText}>{name}</span>
    </div>
  )
}

